// --- Our Modules --------------------------------------------------------------------------------
import constants from "@/config/constants";
import type { TyFetchOptions } from "./types";
// --- Logic --------------------------------------------------------------------------------------
export function buildUrl(path: string, options: TyFetchOptions): string {
    const cleanPath = path.startsWith("/") ? path.slice(1) : path;
    let url = `${constants.url}/${cleanPath}`;

    if (options.query) {
        const parts: string[] = [];
        for (const [key, value] of Object.entries(options.query)) {
            if (value === undefined || value === null) continue;
            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
        }
        if (parts.length > 0) url += `?${parts.join("&")}`;
    }

    return url;
}

function hasFile(data: Record<string, unknown>): boolean {
    return Object.values(data).some((value) => {
        if (value instanceof File) return true;
        if (Array.isArray(value)) return value.some((item) => item instanceof File);
        return false;
    });
}

function toFormData(data: Record<string, unknown>): FormData {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
        if (value === undefined || value === null) continue;
        if (value instanceof File) formData.append(key, value);
        else if (Array.isArray(value) && value.some((item) => item instanceof File)) {
            value.forEach((item) => {
                if (item instanceof File) formData.append(key, item);
            });
        } else if (typeof value === "object") formData.append(key, JSON.stringify(value));
        else formData.append(key, String(value));
    }
    return formData;
}

/** Objects and arrays go as JSON strings inside form-data; the backend's parsing middleware puts them back. */
export function buildBody(data: Record<string, unknown>): { body: BodyInit; contentType?: string } {
    if (hasFile(data)) return { body: toFormData(data) };
    return { body: JSON.stringify(data), contentType: "application/json" };
}
